module.exports = __webpack_public_path__ + "img/qlu_logo.d0666605.png";